import { Application, DynamicScreen } from "ktm-ui/core";
import React from "react";
import { StudioLaunch } from "./StudioLaunch";
import {Button, Modal} from "react-bootstrap";

export class Navigator extends React.Component<{
    appName: string;
    domain: string;
    screen: string;
    branch?: string;
    screenProps: any;
    history: any;
}> {
    state = {
        showModal: false,
        isFirstSignIn: false,
    }

    ready = false;

    async componentDidMount() {
        let app = Application.instance;
        app.navigator = this;
        app.domain = this.props.domain;
        app.appName = this.props.appName;
        app.branch = this.props.branch;
        window.addEventListener("message", this.handleMessage);
        await this.start();
        this.ready = true;
        this.forceUpdate();
    }

    componentWillUnmount() {
        Application.instance.navigator = null;
        window.removeEventListener("message", this.handleMessage);
    }

    async start() {
        let app = Application.instance;
        let sessionResult = await app.session.signin(app);

        const isFirstSignIn = await this.getSignInDetails();
        if (isFirstSignIn) {
            this.setState({ showModal: true });
        }

        let config = sessionResult.config;
        if (config) {
            let components = config.components;
            for (let i = 0; i < components.length; i++) {
                let component = components[i];
                let componentClass = Application.components[component.name] as any;
                if (componentClass) {
                    componentClass.$def = component;
                }
            }
        }

        if (!this.props.screen && sessionResult.homeScreen){
            app.navigate(sessionResult.homeScreen, null, true);
        }
    }

    async getSignInDetails() {
        try {
            const response = await fetch("/api/PlanAdmin/getfirstsignin");
            const res = await response.json();
            if (res.success) {
                return res.isFirstSignIn;
            } else {
                throw new Error("Failed to fetch data");
            }
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    closeModal = () => {
        this.setState({ showModal: false });
    };

    renderModal() {
        if (!this.state.showModal) return null;

        return (
            <Modal show={this.state.showModal} onHide={this.closeModal} style={{ top: 100 }}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: "17px" }}>Welcome to your Plan Administrator Dashboard!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>It looks like it's your first time here.</h4>
                    <br />
                    <p>
                        We highly recommend you book a personalized, 1-on-1 Plan Administration Training with a
                        member of our team in order to be best equipped to manage your plan.
                        <br /><br/>
                        Alternatively, you can view our Easy Answers video tutorial series, which covers basic
                        administrator tasks. 
                        <br/>
                        <strong>How would you like to proceed?</strong>
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <a href="https://calendly.com/training-nationalhealthclaim/30min" target="_blank" rel="noopener noreferrer">
                        <Button variant="secondary">Book a Training Session</Button>
                    </a>
                    <a href="https://vimeo.com/876958629" target="_blank" rel="noopener noreferrer">
                        <Button variant="secondary">View Tutorial Series</Button>
                    </a>
                </Modal.Footer>
            </Modal>
        );
    }


    render() {
        if (!this.ready) return null;

        let app = Application.instance;
        let screen = this.props.screen;
        let content;
        if (screen) {
            let Screen = Application.screens[screen];
            if (Screen) {
                content = <Screen {...this.props.screenProps} />;
            } else {
                content = <DynamicScreen {...this.props.screenProps} screen={screen} />;
            }
        }
        let studioLaunch;
        if (app.studioSettings && app.studioSettings.enabled) {
            studioLaunch = <StudioLaunch />;
        }
        return (
            <>
                {content}
                {studioLaunch}
                {this.renderModal()}
            </>
        );
    }

    handleMessage = (event) => {
        let data = event.data;
        let action = data.action;
        if (action == "studio.ready") {
            Application.instance.studioOpen = true;
            let activeScreen = Application.instance.activeScreens[0];
            if (activeScreen && activeScreen.canvas.screenId) {
                Application.instance.studioWindow.postMessage(
                    {
                        action: "showScreen",
                        screen: activeScreen.canvas.launchParams.screen,
                    },
                    "*"
                );
            }
        } else if ((action = "screen.reload")) {
            let screen = data.screen;
            Application.instance.reloadScreen(screen);
        }
    };

    navigate = (url: string, replace?: boolean) => {
        if (replace) {
            this.props.history.replace(url);
        } else {
            this.props.history.push(url);
        }
    };
}
